
// Class added to identify Route names
export class RouteNames {
    static Login = '';
    static Landing = 'login';
    static Home = 'home';

    
    
  }
  
  export interface ChangePasswordRequest {
    oldPassword: string;
    password: string;
  }

  export interface ChangePinRequest {
  oldPin: string;
  pin: string;
}